import { GetRequisitionDocument, GetRequisitionQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type AtsRequisition = NonNullable<GetRequisitionQuery['ats']['requisition']>

export const useRequisition = (id: string) => {
  const { data, loading } = useQuery(GetRequisitionDocument, { variables: { id } })

  return {
    loading,
    requisition: (data?.ats.requisition as AtsRequisition) || undefined,
  }
}
